/* @flow */
import PageControls from 'payments/components/PageControls.jsx';
import React from 'react';
import FormMoneyInput from 'components/FormMoneyInput.jsx';
import Checkbox from 'components/Checkbox.jsx';

import './styles/ActivityAnnouncementAmountForm.scss';

type Props = {
  onBack: () => void,
  onNext: (data: {amount: number}) => void,
  initialCollectedOnline?: boolean,
  initialAmount: ?number,
};

type State = {
  amount: number,
  collectOnline: boolean,
  isAmountValid: boolean,
};

class ActivityAnnouncementAmountForm extends React.Component {
  props: Props;

  state: State = {
    amount: this.props.initialAmount || 0,
    collectOnline: this.props.initialCollectedOnline === undefined ? true : this.props.initialCollectedOnline,
    isAmountValid: true,
  };

  onAmountValid: Function = (amount: number): void => {
    this.setState({ amount, isAmountValid: true });
  };

  onAmountInvalid: Function = (): void => {
    if (this.state.isAmountValid) {
      this.setState({ isAmountValid: false });
    }
  };

  onBack: Function = (): void => {
    this.props.onBack({
      amount: this.state.amount,
      collectOnline: this.state.collectOnline,
    });
  };

  onNext: Function = (): void => {
    this.props.onNext({
      amount: this.state.amount,
      collectOnline: this.state.collectOnline,
    });
  };

  toggleCollectOnline: Function = (): void => {
    this.setState(({ collectOnline }) => ({ collectOnline: !collectOnline }));
  };

  isValid: Function = (): boolean => {
    return this.state.isAmountValid;
  };

  render() {
    return (
      <div>
        <div className="ActivityAnnouncementAmountForm-amountInput">
          <FormMoneyInput
            allowZeroValue
            onValidChange={this.onAmountValid}
            onInvalidChange={this.onAmountInvalid}
            initialCentValue={this.props.initialAmount}
            currency="USD"
          />

          {this.state.amount > 0 &&
            <Checkbox
              name="collect_online"
              label="Use Remind to collect funds for this activity"
              checked={this.state.collectOnline}
              onChange={this.toggleCollectOnline}
            />
          }
        </div>

        <PageControls
          className="ActivityAnnouncementAmountForm-controls"
          disabledNext={!this.isValid()}
          nextText={this.state.amount === 0 ? 'Skip' : 'Next'}
          onBack={this.onBack}
          onNext={this.onNext}
        />
      </div>
    );
  }
}

export default ActivityAnnouncementAmountForm;



// WEBPACK FOOTER //
// ./src/payments/components/ActivityAnnouncementAmountForm.jsx